import React, {useState, useEffect} from 'react'

import Message from './Message'
import LoadingIndicator from './LoadingIndicator'
import axios from 'axios'
import {ChatOpenAI} from '@langchain/openai'
import { OpenAIEmbeddings } from "@langchain/openai";
import { RecursiveCharacterTextSplitter } from "langchain/text_splitter";

import { Document } from "@langchain/core/documents";
//import { PDFLoader } from "langchain/document_loaders/fs/pdf";



// import { HuggingFaceTransformersEmbeddings } from "@langchain/community/embeddings/hf_transformers";
// import { DirectoryLoader } from "langchain/document_loaders/fs/directory";
// import { JSONLoader } from "langchain/document_loaders/fs/json";
// import { TextLoader } from "langchain/document_loaders/fs/text";
// import { CSVLoader } from "langchain/document_loaders/fs/csv";
//import { PDFLoader } from "@langchain/community/document_loaders/fs/pdf";
// import { FaissStore } from "@langchain/community/vectorstores/faiss";


//import { PromptTemplate } from "langchain/prompts";
//import {
//    RunnableSequence,
//    RunnablePassthrough,
//} from "langchain/schema/runnable";

//import {PDFLoader} from 'langchain/document_loaders/fs/pdf';
//import { CharacterTextSplitter } from 'langchain/text_splitter';
//import { StringOutputParser } from "langchain/schema/output_parser";
//import { Pinecone} from '@pinecone-database/pinecone';
//import {Document}  from 'langchain/document';
//import {PineconeStore} from 'langchain/vectorstores/pinecone';


const ChatWindow = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState('');

  const API_KEY = "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";
  const loadFromLocalStorage = () => {
    const chatHistory = localStorage.getItem('chatHistory');
    if (chatHistory) {
        return [];
        //return JSON.parse(chatHistory);
    } else {
        return [];
    }
  }
  const saveToLocalStorage = (chatHistory) =>{
    localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
  }

  useEffect(() => {
    const chatHistory = loadFromLocalStorage();
     setMessages(chatHistory);
    //setMessages('');
  }, []);

  useEffect(() => {
    const savedMessages = loadFromLocalStorage();
    if(savedMessages.length > 0){
        setMessages(savedMessages);
        //setMessages('');
    }
  }, []);

  const sendMessage = async (userInput) =>{
    const userMessage = {sender:'user', text:userInput};
    setMessages([...messages, userMessage]);
    saveToLocalStorage([...messages, userMessage]);
    setLoading(true);

    // headers for API call
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + API_KEY
    }

    const data = {
        model: 'gpt-4',
        messages: [{role:'user', content:input}]
    }

    try{
        const response = await axios.post(
         'https://api.openai.com/v1/chat/completions', 
          data,
          {headers}
        )
        console.log("Response: ", response);
        const aiMessage = {
            sender: 'api',
            text:response.data.choices[0].message.content.trim()
        }

        setMessages([...messages, userMessage, aiMessage]);
        saveToLocalStorage([...messages, userMessage, aiMessage]);

    } catch(error){
        console.log(error);
    }
    setLoading(false);

  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(input.trim() !== ''){
        sendMessage(input);
        setInput('');
    }
  };
  const handleInput = (e) => {
    setInput(e.target.value);
  };
  return (
    <div>
      {messages.map((message, index) =>(
        <Message key={index} sender={message.sender}
                text={message.text} />
      ))
    }
    { loading &&  <LoadingIndicator /> }
    <form onSubmit={handleSubmit}>
        <input
        type="text"
        value={input}
        onChange={handleInput} />
        <button type="submit"> Send</button>
    </form>
    </div>
  )
}

export default ChatWindow
